import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ContentSection } from '../components/ContentSection';
import { VideoSection } from '../components/VideoSection';
import { BonusSection } from '../components/BonusSection';
import { CertificateSection } from '../components/CertificateSection';
import { OrderBumpSection } from '../components/OrderBumpSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { SocialProofPopup } from '../components/SocialProofPopup';
export function LandingPage() {
  return <main className="w-full min-h-screen" data-id="element-275">
      <HeroSection data-id="element-276" />
      <ProblemSection data-id="element-277" />
      <SolutionSection data-id="element-278" />
      <ContentSection data-id="element-279" />
      <VideoSection data-id="element-280" />
      <BonusSection data-id="element-281" />
      <CertificateSection data-id="element-282" />
      <OrderBumpSection data-id="element-283" />
      <TestimonialsSection data-id="element-284" />
      <PricingSection data-id="element-285" />
      <FAQSection data-id="element-286" />
      <SocialProofPopup data-id="element-287" />
    </main>;
}